'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 142px;\n  display: flex;\n  align-items: center;\n  cursor: ', ';\n  user-select: none;\n'], ['\n  max-width: 142px;\n  display: flex;\n  align-items: center;\n  cursor: ', ';\n  user-select: none;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Step = _styledComponents2.default.div(_templateObject, function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'default' : 'pointer';
});

exports.default = Step;